import React from 'react';
import { Button, Layout, Footer } from 'components';
import { Row, Col } from 'antd';

import './order-successful.less';
import 'components/box/box.less';
import checked from 'assests/images/fail-kk.png';

import RejectBorderIcon from '../../assests/icons/rejected-border.icon';
import {  useLocation } from 'react-router-dom';

const OrderError = () => {
  let location = useLocation();
  const data = location.state;
  return (
    <Layout>
      <div className="page-order-successfull">
        <div className="container">
          <figure>
            <img src={checked} alt="Checked Image" />
          </figure>
          <h1 className="section__title">
           HATA OLUŞTU
          </h1>
          <p className="info-text">
            Ödeme aşamasında bir hata oluştu lütfen sonra tekrar deneyiniz.
          </p>
           <Button
            type="primary"
            htmlType="submit"
            shape="round"
            className="login-button"
            href="/Messages"
          >
            Ana Sayfaya Dön
          </Button>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default OrderError;
